import React, { useState, memo } from "react";
import { makeStyles } from "@mui/styles";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import CloseIcon from "@mui/icons-material/Close";
import GetAppIcon from "@mui/icons-material/GetApp";
import { getDictation, getIVRCallAudio } from "apiHandler/actions";
import { useUserData } from "./customHooks/userDataContext";
import Player from "../components/scribe/AudioPlayer";
import {
  CircularProgress,
  Fab,
  IconButton,
  Popper,
  Typography,
} from "@mui/material";
import { green } from "@mui/material/colors";

const useStyles = makeStyles(() => ({
  wrapper: {
    margin: 0,
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
  fabProgress2: {
    color: green[500],
    position: "absolute",
    top: -4,
    left: -4,
    zIndex: 1,
  },
  buttonClassname: {
    // width: 32,
    // height: 32,
    width: 20,
    height: 20,
  },
  downloadBtn: {
    cursor: "pointer",
  },
}));

const AudioIcon = (props) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [audio, setAudio] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [error, setError] = useState(false);
  const [mimeType, setMimeType] = useState("audio/mpeg");
  const { id, currentPlaying, setCurrentPlaying, practice_id } = props;
  const userData = useUserData();
  const token = userData?.access_token;

  const fetchAudio = async (download, event) => {
    setAnchorEl(event.currentTarget);
    if (id !== currentPlaying) {
      await setCurrentPlaying(id);
    }
    let response = audio;
    if (error) {
      return;
    }
    if (!loading && !audio && props.id && !error) {
      if (download) setError("Download in progress...");
      else await setLoading(true);
      const payload = {
        type: "Dictation",
        search_criteria: {
          practice_id: practice_id,
          npi: props.npi,
          dictation_id: props.id,
        },
      };
      if (props.isIVRCall) {
        response = await getIVRCallAudio(
          {
            practice_id: props.practice_id.toString(),
            id: props.id.toString(),
          },
          token
        );
      } else {
        console.log("payload", payload);
        response = await getDictation(payload, token);
      }
      if (response === "ERROR" || !response) {
        setError("Failed to get the audio");
        setLoading(false);
        setTimeout(() => {
          handleClosePlayer();
        }, 3000);
        return;
      } else {
        await setMimeType(response.mimeType);
        await setAudio(response);
        await setError("");
      }
    }
    if (download) {
      await setCurrentPlaying(null);
      const link = document.createElement("a");
      link.href = response;
      link.setAttribute("download", `${props.id}.${props.ext || "mp3"}`);
      document.body.appendChild(link);
      link.click();
    } else {
      setLoading(false);
      await setCurrentPlaying(id);
    }
  };
  const handleClosePlayer = () => {
    setCurrentPlaying(null);
    setAnchorEl(null); // Close Popper
  };

  return (
    <div className={classes.wrapper}>
      <Fab
        aria-label="save"
        size="small"
        onClick={(event) => fetchAudio(false, event)}
        style={{
          width: 30,
          height: 30,
          minHeight: "auto",
          borderRadius: 15,
          marginRight: 2,
        }}
      >
        <PlayArrowIcon className={classes.buttonClassname} color="primary" />
      </Fab>
      <GetAppIcon
        color="secondary"
        onClick={(event) => fetchAudio(true, event)}
        className={classes.downloadBtn}
      />
      <br />
      {/* {loading && (
        <CircularProgress size={53} className={classes.fabProgress} />
      )} */}
      {loading && (
        <CircularProgress
          size={39}
          color="primary"
          className={classes.fabProgress2}
        />
      )}
      {id === currentPlaying && (audio || error) && (
        <Popper
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          placement="bottom-start" // Set placement to bottom-start for bottom-left positioning
          modifiers={[
            {
              name: "offset",
              options: {
                offset: [10, 10], // Adjust the offset values for fine-tuning
              },
            },
          ]}
          sx={{ position: "absolute" }}
        >
          <div
            style={{
              backgroundColor: "rgb(50, 50, 50)",
              display: "flex",
              padding: "10px",
            }}
          >
            {error ? (
              <Typography color="error">{error}</Typography>
            ) : props.showPlayer ? (
              <Player audio={audio} />
            ) : (
              <audio src={audio} type={mimeType} controls autoPlay />
            )}
            <IconButton
              size="small"
              aria-label="close"
              sx={{ color: "#fff", ml: 2 }}
              onClick={handleClosePlayer}
            >
              <CloseIcon
                fontSize="small"
                style={{ color: "#fff" }}
                onClick={handleClosePlayer}
              />
            </IconButton>
          </div>
        </Popper>
        // <Snackbar
        //   anchorOrigin={anchorOrigin}
        //   onClose={handleClose}
        //   autoHideDuration={error ? 2000 : null}
        //   TransitionComponent={(props) => <Slide {...props} direction="up" />}
        //   open={open}
        //   message={

        //   }
        //   action={
        //     <Fragment>
        //       <IconButton
        //         size="small"
        //         aria-label="close"
        //         color="inherit"
        //         onClick={() => setCurrentPlaying(null)}
        //       >
        //         <CloseIcon fontSize="small" />
        //       </IconButton>
        //     </Fragment>
        //   }
        // />
      )}
    </div>
  );
};

export default memo(AudioIcon);
